import '../common/window'
import '../common/eshop'
import '../common/modal/modal-back'
import '../common/modal/modal-jump'
import '../common/info-messages'
import '../common/toggle-password'
import '../common/product-cart-quantity'
import '../common/cookiebot';
import { updateLazy } from '../common/lazy'
import { buildStars } from '../common/stars'
import { initTippy } from '../common/tippy';
import { initCountdowns } from '../common/countdown';
import '../components/spinner-quick-update'
import '../components/header'
import '../components/footer'

window.Cart.customCallbacks.addedItem = function(form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', {form, response})
}
window.Cart.customCallbacks.updatedItem = function(input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', {input, response})
}
window.Cart.customCallbacks.removedItem = function(form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', {form, response})
}

buildStars()
updateLazy()
initTippy()

if (document.querySelector('.js-countdown')) {
    initCountdowns()
}

rEvent.on('Listing.fetchedData', () => {
    buildStars()
    updateLazy()
    initTippy()
})

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        back.addEventListener('click', event => {
            if (event.currentTarget.getAttribute('href') == '#') {
                window.history.back()
            }
        })
    })
})

rEvent.on('Cart.fetchedProducts', function ({ response }) {
    if (!response.data.count) {
        return
    }

    for (var productId in response.data.items) {
        var product = response.data.items[productId],
            variantName = ""

        if (Object.keys(product).length === 0) {
            continue;
        }

        if (product.has_variations && product.selected_variation_values) {
            if (Array.isArray(product.selected_variation_values)) {
                variationName = product.selected_variation_values.map(function (variationValue) {
                    return variationValue.name
                }).join(", ");
            } else {
                var variantNameArray = []
                for (const variationId in product.selected_variation_values) {
                    variantNameArray.push(product.selected_variation_values[variationId].name)
                }

                variantName = variantNameArray.join(", ");
            }
        }

        EcommerceTracking.data['Products'][productId] = {
            categoryName: product.category.name,
            manufacturerName: product.manufacturer ? product.manufacturer.name : "",
            manufacturerId: product.manufacturer ? product.manufacturer.id : "",
            manufacturerFbPixel : product.manufacturer ? product.manufacturer.custom_fb_pixel : "",
            productId: productId,
            productName: product.name,
            productPrice: product.price,
            productStatus: product.status,
            variantName: variantName
        }
    }

    rEvent.dispatch('Tracking.fetchedCartProducts');
});